export class Bank{
  id:number;
  title:string;
}
